<template>
  <v-list exact>
    <MainMenuItem icon="mdi-home" :title="$t('app.home')" link="AppStart" />

    <template v-if="!$auth.loading">
      <template v-if="!$auth.isAuthenticated">
        <!-- Logged out only items here -->
        <v-list-item exact link :to="{name: 'AppLogin'}">
          <v-list-item-action>
            <v-icon>mdi-login</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="body-1">{{ $t('app.login') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link exact :to="{name: 'AppDocuments'}">
          <v-list-item-action>
            <v-icon>mdi-file-pdf-box</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="body-1">{{ $t('app.rightsholder-forms') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <template v-if="$auth.isAuthenticated">
        <!-- Logged in only items here -->

        <MainMenuItem
          icon="mdi-file-document-multiple-outline"
          link="AppDocuments"
          :title="$t('menu.docs')"
        />
        <MainMenuItem
          v-if="currentRightsholderId"
          icon="mdi-account-box-multiple-outline"
          link="Rightsholders"
          :title="$t('menu.rightsholders')"
        />
        <MainMenuItem 
          v-if="currentRightsholderId"
          icon="mdi-cash" 
          link="Statements" 
          :title="$t('menu.statements')" 
        />

        <v-list-group
          v-if="currentRightsholderId"
          prepend-icon="mdi-view-sequential-outline" 
          :value="['CurrentRights', 'UnclaimedRights', 'StagingArea', 'ClaimForms'].includes($route.name)">
          <template v-slot:activator>
            <v-list-item-title>{{ $t('menu.rights') }}</v-list-item-title>
          </template>

          <MainMenuItem
            icon="mdi-view-sequential-outline"
            link="CurrentRights"
            :title="$t('menu.currentRights')"
          />
          <MainMenuItem
            icon="mdi-view-sequential-outline"
            link="UnclaimedRights"
            :title="$t('menu.unclaimedRights')"
          />
          <MainMenuItem
              icon="mdi-view-sequential"
              link="StagingArea"
              :title="$t('menu.staging')"
          />
          <MainMenuItem
              icon="mdi-form-select"
              link="ClaimForms"
              :title="$t('menu.claimforms')"
          />
        </v-list-group>

        <MainMenuItem @click="logout" icon="mdi-logout" :title="$t('app.logout')" />
      </template>
    </template>
  </v-list>
</template>

<script>
import {mapGetters} from "vuex";
import MainMenuItem from "@/components/common/MainMenuItem.vue";

export default {
  name: "MainMenu",

  components: {
    MainMenuItem,
  },

  computed: {
    ...mapGetters('app', ['currentRightsholder']),

    currentRightsholderId() {
      return this.currentRightsholder.id;
    }

  },

  methods: {
    async logout() {
      const res = await this.$dialog.confirm({
        text: this.$t("app.logout-confirm"),
        title: this.$t("app.logout"),
      });
      if (res) {
        this.$auth.logout({
          returnTo: window.location.origin,
        });
      }
    },
  },
};
</script>

<style>
</style>